var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5002H5C3.61917 18.5002 2.5 17.381 2.5 16.0002V9.3335C2.5 7.95266 3.61917 6.8335 5 6.8335H15C16.3808 6.8335 17.5 7.95266 17.5 9.3335V16.0002C17.5 17.381 16.3808 18.5002 15 18.5002Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 6.8335C6.66667 4.99266 8.15917 3.50016 10 3.50016C11.8408 3.50016 13.3333 4.99266 13.3333 6.8335H15C15 4.07183 12.7617 1.8335 10 1.8335C7.23833 1.8335 5 4.07183 5 6.8335H6.66667Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.9165C10.6904 13.9165 11.25 13.3569 11.25 12.6665C11.25 11.9761 10.6904 11.4165 10 11.4165C9.30964 11.4165 8.75 11.9761 8.75 12.6665C8.75 13.3569 9.30964 13.9165 10 13.9165Z",
    fill: "#6C6C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.9165C14.857 13.9165 15.4167 13.3569 15.4167 12.6665C15.4167 11.9761 14.857 11.4165 14.1667 11.4165C13.4763 11.4165 12.9167 11.9761 12.9167 12.6665C12.9167 13.3569 13.4763 13.9165 14.1667 13.9165Z",
    fill: "#6C6C6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 13.9165C6.52367 13.9165 7.08331 13.3569 7.08331 12.6665C7.08331 11.9761 6.52367 11.4165 5.83331 11.4165C5.14296 11.4165 4.58331 11.9761 4.58331 12.6665C4.58331 13.3569 5.14296 13.9165 5.83331 13.9165Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.d5e6a8bbf3a48cb96e01b9aa638368ac.svg";
export { ForwardRef as ReactComponent };